import * as React from "react"
const DebitActive = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <g data-name="Group 115363">
      <g data-name="icons8-invoice (1)">
        <path
          fill="#ffca40"
          d="M24 4.263A1.263 1.263 0 0 0 22.737 3H1.263A1.263 1.263 0 0 0 0 4.263v16.421a1.263 1.263 0 0 0 1.263 1.263h21.474A1.263 1.263 0 0 0 24 20.684Z"
          data-name="Path 100845"
        />
        <path
          fill="#aa821b"
          d="M20.368 8.053H3.316A.316.316 0 0 1 3 7.737V6.474a.316.316 0 0 1 .316-.316h17.052a.316.316 0 0 1 .316.316v1.263a.316.316 0 0 1-.316.316Z"
          data-name="Path 100846"
        />
        <path
          fill="#aa821b"
          d="M20.526 11.21h-1.263a.316.316 0 0 1-.316-.316v-.632a.316.316 0 0 1 .316-.315h1.263a.316.316 0 0 1 .316.316v.632a.316.316 0 0 1-.316.315Z"
          data-name="Path 100847"
        />
        <path
          fill="#aa821b"
          d="M15.947 11.21H3.316A.316.316 0 0 1 3 10.894v-.632a.316.316 0 0 1 .316-.315h12.631a.316.316 0 0 1 .316.316v.632a.316.316 0 0 1-.316.315Z"
          data-name="Path 100848"
        />
        <path
          fill="#aa821b"
          d="M20.526 13.737h-1.263a.316.316 0 0 1-.316-.316v-.632a.316.316 0 0 1 .316-.315h1.263a.316.316 0 0 1 .316.316v.632a.316.316 0 0 1-.316.315Z"
          data-name="Path 100849"
        />
        <path
          fill="#aa821b"
          d="M14.684 13.737H3.316A.316.316 0 0 1 3 13.421v-.632a.316.316 0 0 1 .316-.315h11.368a.316.316 0 0 1 .316.316v.632a.316.316 0 0 1-.316.315Z"
          data-name="Path 100850"
        />
        <path
          fill="#aa821b"
          d="M20.526 16.263h-1.263a.316.316 0 0 1-.316-.316v-.632a.316.316 0 0 1 .316-.315h1.263a.316.316 0 0 1 .316.316v.632a.316.316 0 0 1-.316.315Z"
          data-name="Path 100851"
        />
        <path
          fill="#aa821b"
          d="M15.947 16.263H3.316A.316.316 0 0 1 3 15.947v-.632A.316.316 0 0 1 3.316 15h12.631a.316.316 0 0 1 .316.316v.632a.316.316 0 0 1-.316.315Z"
          data-name="Path 100852"
        />
        <path
          fill="#aa821b"
          d="M20.526 20.052h-5.684a.316.316 0 0 1-.316-.316v-.632a.316.316 0 0 1 .316-.315h5.684a.316.316 0 0 1 .316.316v.632a.316.316 0 0 1-.316.315Z"
          data-name="Path 100853"
        />
      </g>
    </g>
  </svg>
)
export default DebitActive
